<template>
<ValidationObserver ref="observer">
  <form ref="add_part_dealer_form" @submit.prevent="addPartDealer">

    <md-card>

      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          Add Part Dealer
        </h4>
      </md-card-header> -->
      <md-card-content>
 
        <!-- <div class="md-layout">
          <label class="md-layout-item md-size-15 md-form-label">
            Dealer No. (Read)<span style="color:red"> *</span>
          </label>
          <div class="md-layout-item">
            <validation-provider rules="dealerno" v-slot="{ errors }">
            <md-field class="md-invalid">
              <md-input v-model="dealer_no" readonly/>
              <validation-error :errors="apiValidationErrors.dealer_no" />
            </md-field>
            <span>{{ errors[0] }}</span>
            </validation-provider>
          </div>
        </div> -->

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Dealer Name</span><span style="color:red"> *</span>
          </label> -->
              <validation-provider rules="dealername" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Dealer Name</label>
                <md-input v-model="dealer_name" required/>
                <validation-error :errors="apiValidationErrors.dealer_name" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
          </div>

          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Use PPN</span><span style="color:red"> *</span>
            </label> -->
              <validation-provider rules="useppn" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label>Use PPN</label>
                <md-select v-model="dealer_use_ppn" required>
                <md-option value="Yes">Yes</md-option>
                <md-option value="No">No</md-option>
                
              </md-select>
                <validation-error :errors="apiValidationErrors.dealer_use_ppn" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
      
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Dealer Attn</span>
          </label> -->
              <md-field class="md-invalid">
                <label>Dealer Attn</label>
                <md-input v-model="dealer_attn" required/>
                <validation-error :errors="apiValidationErrors.dealer_attn" />
              </md-field>
          </div>        
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Phone</span>
            </label> -->
              <md-field class="md-invalid">
                <label>Phone</label>
                <md-input v-model="dealer_phone" required/>
                <validation-error :errors="apiValidationErrors.dealer_phone" />
              </md-field>
          </div>
        </div>
      
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Bank Name</span>
          </label> -->
              <md-field class="md-invalid">
                <label>Bank Name</label>
                <md-input v-model="dealer_bank_name" required/>
                <validation-error :errors="apiValidationErrors.dealer_bank_name" />
              </md-field>
          </div>
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Bank Account Number</span>
            </label> -->
              <md-field class="md-invalid">
                <label>Bank Account Number</label>
                <md-input v-model="dealer_bank_account" type="text" v-on:keypress="NumbersOnly" required/>
                <validation-error :errors="apiValidationErrors.dealer_bank_account" />
              </md-field>
            </div>
        </div>

        <div class="md-layout md-glutter">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Address</span>
          </label> -->
            <md-field class="md-invalid">
              <label>Address</label>
              <md-textarea v-model="dealer_address" md-counter="100" maxlength="100" md-autogrow required></md-textarea>
              <md-avatar >
                <md-icon style="color:blue;">report</md-icon>
                <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
              </md-avatar>
              <validation-error :errors="apiValidationErrors.dealer_address" />
            </md-field>
          </div>
        </div>
      
        <div class="md-layout md-glutter">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Remark</span>
          </label> -->
              <md-field class="md-invalid">
                <label for="">Remark</label>
                <md-textarea v-model="dealer_remark" md-counter="100" maxlength="100" md-autogrow></md-textarea>
                <md-avatar >
                  <md-icon style="color:blue;">report</md-icon>
                  <md-tooltip md-direction="left">You can enter to add new row</md-tooltip>
                </md-avatar>
                <validation-error :errors="apiValidationErrors.dealer_remark" />
              </md-field>
          </div>
        </div>

         


      </md-card-content>
      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <md-button class="md-dense"  @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {extend , ValidationObserver} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);

// mengirim pesan error ketika required field tidak diisi
extend('useppn', {
  ...required,
  message: 'Use PPN field is required'
});
extend('dealername', {
  ...required,
  message: 'Dealer Name field is required'
});
extend('dealerno', {
  ...required,
  message: 'Dealer No. field is required'
});

export default {
  name: "add-part-dealer",

  props: {
      data: Object
  },

  components: {ValidationError, ValidationObserver},

  mixins: [formMixin],

  data: () => ({
    // dealer_no: null,
    dealer_name: null,
    dealer_use_ppn: null,
    dealer_attn: null,
    dealer_phone: null,
    dealer_address: null,
    dealer_bank_name: null,
    dealer_bank_account: null,
    dealer_remark: null,
  }),
  
  created() {
    this.getLastNo();
  },
    
  methods: {
    async getLastNo(){
          //  await this.$store.dispatch("workshop_part_dealer/last_no")
          //  this.dealer_no =  await this.$store.getters["workshop_part_dealer/part_dealer"]
           
        //this.$refs.procurement_order_no_input.$el.focus();
        //this.$refs.procurement_order_remark_input.$el.focus();
    },
    
    //fungsi direct ke list view table
    backtoList(id) {
      this.$router.replace({ name: 'List Part Dealer' })
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },

    // validasi add data menggunakan vue-alert
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, save it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addPartDealer()
        }
      });
    },
    
    // kirim data add ke api
    async addPartDealer() {
      const data = {
        type: "workshop_part_dealers",
        // dealer_no: this.dealer_no,
        dealer_name: this.dealer_name,
        dealer_use_ppn: this.dealer_use_ppn,
        dealer_attn: this.dealer_attn,
        dealer_phone: this.dealer_phone,
        dealer_address: this.dealer_address,
        dealer_bank_name: this.dealer_bank_name,
        dealer_bank_account: this.dealer_bank_account,
        dealer_remark: this.dealer_remark,
      }
      try {
        // kirim data
        await this.$store.dispatch("workshop_part_dealer/add", data);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Successfully Added."
        );
        // kembali ke list part dealer
        await this.$router.replace({name: 'List Part Dealer'});
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong gan"
        );
        this.setApiValidation(e.response.data.errors);
      }

    }
  }
};
</script>
